import React, { memo } from 'react'

import { Button, Hide, Icon, Show, classnames } from '@cgtrader/triangle-ui/dist/src/ssr-index'
import { arrayOf, bool, func, number, shape, string } from 'prop-types'

import { NOOP } from 'Utils/stableDefaults'

function toHexColor(segmentationColor) {
  return `#${Number(segmentationColor || 0).toString(16).padStart(6, '0')}`
}

function SegmentList({ meshes, selectedMeshId = null, onToggleVisibility = NOOP }) {
  return (
    <ul className="segment-tab__list">
      {meshes.map(({ uuid, name, segmentationColor, visible = true }) => (
        <li
          key={uuid}
          className={classnames(
            'segment-tab__list-item',
            uuid === selectedMeshId && 'segment-tab__list-item--selected',
          )}
        >
          <span
            className="segment-tab__list-swatch"
            style={{ backgroundColor: toHexColor(segmentationColor) }}
          />
          <span className="segment-tab__list-label cgt-body-base">{name}</span>
          <div className="segment-tab__list-actions">
            <Button
              type="ghost"
              variant="only-icon"
              size="tiny"
              customClass="segment-tab__list-action"
              aria-label={visible ? `Hide ${name}` : `Show ${name}`}
              aria-pressed={!visible}
              onClick={() => onToggleVisibility(uuid, !visible)}
              icon={(
                <Icon svgComponent={visible ? Show : Hide} size="small" color="dark" notSpaced />
              )}
            />
          </div>
        </li>
      ))}
    </ul>
  )
}

SegmentList.propTypes = {
  meshes: arrayOf(shape({
    uuid: string.isRequired,
    name: string,
    segmentationColor: number,
    visible: bool,
  })).isRequired,
  selectedMeshId: string,
  onToggleVisibility: func,
}

export default memo(SegmentList)
